import { V2 } from '@eventr/common'
import { SectionV2Provider } from '../state/sectionProvider'
import { PastSorter } from './pastSorter'
import UniversalRenderer from './universal/universal'

export type ScreenType = 'personal' | 'team' | 'edit' | 'upNext' | 'teamMember'
interface IRendererLocatorProps {
    data: V2
    screenType: ScreenType
    isPublic?: boolean
    id?: string
}
export const RendererLocator = ({
    data,
    screenType,
    isPublic,
    id,
}: IRendererLocatorProps) => {
    const getRenderer = () => {
        switch (data.renderer) {
            case 'universal':
                return <UniversalRenderer screenType={screenType} data={data} />
            case 'pastSorter':
                return (
                    <PastSorter screenType={screenType} data={data} id={id} />
                )
            default:
                return <div />
        }
    }

    return (
        <SectionV2Provider sectionData={data} isPublic={isPublic}>
            {getRenderer()}
        </SectionV2Provider>
    )
}
